import React from 'react'
import { compose } from 'recompose'
import withSession from 'components/withSession'
import withCurrentUser from 'components/withCurrentUser'
import AuthenticatedNavLink from './AuthenticatedNavLink'
import Container from '../Container'
import PlatformLink from '../PlatformLink'

const MultiServerPlatformNavLink = ({
  session: { isAuthenticated },
  platform,
  currentUser,
  children,
  ...rest
}) => {
  const servers = currentUser && currentUser.userServers(platform.id)
  return (
    <Container>
      {isAuthenticated && servers ? (
        <AuthenticatedNavLink
          servers={servers}
          platform={platform}
          children={children}
          {...rest}
        />
      ) : (
        <PlatformLink href={platform.loginUrl}>{children}</PlatformLink>
      )}
    </Container>
  )
}

export default compose(withSession, withCurrentUser)(MultiServerPlatformNavLink)



// WEBPACK FOOTER //
// ./src/routes/home/components/MultiServerPlatformNavLink/index.js